/// <reference types="user-agent-data-types" />

import { useEffect } from 'react';
import { useAppSelector } from 'appRedux/hooks';
import { ga, zd } from 'utils';
import { ICustomer } from 'interfaces';

export const useTracker = () => {
  const { loaded: userDataLoaded } = useAppSelector(({ user }) => user);

  useEffect(() => {
    const shouldIdentify = localStorage.getItem('shouldIdentify');
    if (userDataLoaded && shouldIdentify) {
      const storageUser = JSON.parse(
        localStorage.getItem('userData') || 'null'
      ) as ICustomer | null;
      if (storageUser) {
        localStorage.removeItem('shouldIdentify');
        ga().identify(storageUser.id, {
          email: storageUser.email ?? '',
          firstName: storageUser.first_name ?? '',
          lastName: storageUser.last_name ?? '',
          gender: storageUser.gender ?? '',
          userAgent: window.navigator.userAgentData
            ? window.navigator.userAgentData
            : window.navigator.userAgent
        });
        zd().identify('webWidget', 'identify', {
          name: storageUser.name,
          email: storageUser.email
        });
      }
    }
  }, [userDataLoaded]);
};
